const Providers = {
  ELEV8: "verticalimpression",
  HIVESTACK: "hivestack",
  VISTAR: "vistar",
  NOVA: "nova",
  BROADSIGN: "broadsign",
  PLACE_EXCHANGE: "placeexchange",
  FAKE: "https://verticalcity.com",
  UNKNOWN: "unknown",
} as const;
type Provider = (typeof Providers)[keyof typeof Providers];

function determineProvider(url: string): Provider {
  if (url === Providers.FAKE) return Providers.FAKE;
  if (url.includes(Providers.ELEV8)) return Providers.ELEV8;
  if (url.includes(Providers.HIVESTACK)) return Providers.HIVESTACK;
  if (url.includes(Providers.VISTAR)) return Providers.VISTAR;
  if (url.includes("screenverse")) return Providers.NOVA; // Nova is a Vistar proxy served from nova-na.screenverse.io; elev8-central tags it provider "nova"
  if (url.includes(Providers.BROADSIGN)) return Providers.BROADSIGN;
  if (url.includes(Providers.PLACE_EXCHANGE)) return Providers.PLACE_EXCHANGE;
  return Providers.UNKNOWN;
}

export { Providers, type Provider, determineProvider };
